// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1FBTv","empty":"ModalGraph_empty__2bza2"};